/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {tokens} from '@packages/utilities/styled';
import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const AddPanelCollectionlist64Icon = React.forwardRef<
  HTMLDivElement,
  BaseIconProps
>(({size = 64, ...props}, ref) => {
  return (
    <BaseIcon {...props} size={size} ref={ref}>
      <svg
        data-wf-icon="AddPanelCollectionlist64Icon"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path
            opacity="0.15"
            d="M16 17C16 16.4477 16.4477 16 17 16H47C47.5523 16 48 16.4477 48 17V47C48 47.5523 47.5523 48 47 48H17C16.4477 48 16 47.5523 16 47V17Z"
            fill={tokens.colors.purpleBackground}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M47 16C47.5523 16 48 16.4477 48 17V47C48 47.5523 47.5523 48 47 48H17C16.4477 48 16 47.5523 16 47V17C16 16.4477 16.4477 16 17 16H47ZM17 38V47H47V38H17ZM17 37H47V27H17V37ZM17 26H47V17H17V26Z"
            fill={tokens.colors.purpleText}
          />
        </g>
      </svg>
    </BaseIcon>
  );
}) as IconComponent;

AddPanelCollectionlist64Icon.tags = [
  'panel',
  'list',
  'collection',
  'grid',
  'sections',
];

AddPanelCollectionlist64Icon.category = '64x64 (Add panel)';

AddPanelCollectionlist64Icon.iconSize = 64;
